export type AvailableCountPrintFilters = {
  vesselId?: string;
};

export function availableCountPrintPath(filters: AvailableCountPrintFilters = {}): string {
  const qs = new URLSearchParams();
  if (filters.vesselId?.trim()) qs.set('vesselId', filters.vesselId.trim());
  const s = qs.toString();
  return `/crew/statistics/available/print${s ? `?${s}` : ''}`;
}

export function availableCountListApiUrl(params: URLSearchParams): string {
  const today = new Date().toISOString().slice(0, 10);
  const qs = new URLSearchParams({
    withinDays: '90',
    periodFrom: today,
    periodTo: today,
  });
  const vesselId = params.get('vesselId')?.trim();
  if (vesselId) qs.set('vesselId', vesselId);
  return `/crew/reports/statistics?${qs.toString()}`;
}

export function availableCountBackPath(): string {
  return '/crew/statistics/available';
}
